// extracted by mini-css-extract-plugin
export default {"columnTitle":"useHeaderColumnProps_columnTitle__c-hFa","placeHolderShimmer":"useHeaderColumnProps_placeHolderShimmer__j2H0c"};